import { useMutation, useQueryClient } from "@tanstack/react-query";

import { eventDetailQueryKey } from "@/hooks/useEventQuery";
import {
  markAllEventsSeen,
  markEventSeen,
  markEventUnseen,
} from "@/lib/eventsApi";

export function useMarkEventSeen() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => markEventSeen(id),
    onSuccess: (_data, id) => {
      void qc.invalidateQueries({ queryKey: ["events"] });
      void qc.invalidateQueries({ queryKey: eventDetailQueryKey(id) });
    },
  });
}

export function useMarkEventUnseen() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => markEventUnseen(id),
    onSuccess: (_data, id) => {
      void qc.invalidateQueries({ queryKey: ["events"] });
      void qc.invalidateQueries({ queryKey: eventDetailQueryKey(id) });
    },
  });
}

export function useMarkAllEventsSeen() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: () => markAllEventsSeen(),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["events"] });
    },
  });
}
